<div #container class="route-cont {{animation}} animated" *ngIf="routes">
  <div class="header">
    <span class="title">{{'BUS_RESULTS_MODULE.BUSES' | transloco}}</span>
    <a (click)="goBack()" class="close-button">
      <i aria-hidden="true" class="icon-close"></i>
    </a>
  </div>
  <div class="body" #bodycontainer>
    <div *ngFor="let route of routes">
      <div class="trip-header">
        <hr *ngIf="isReturnHeader(route)" class="divider" />
        <span>{{ tripTypeHeader(route) | transloco }}</span>
        <p class="type-date">{{route.FlightItem.DepartureDate | date: 'EEEE, d MMM yyyy' | dateFormat }}</p>
      </div>
      <app-bus-route-detail [busClass]="busClass" [provider]="provider" [routeInfo]="route">
      </app-bus-route-detail>
    </div>
  </div>
  <div class="btn-selection">
    <app-fixed-surface
      [boxShadow]="true">
      <app-ds-button
        [labels]="{ ButtonLabel: 'BUS_RESULTS_MODULE.SELECT_BUSES_DETAIL' | transloco: { price: price } }"
        (clickEvent)="selectBus()">
      </app-ds-button>
    </app-fixed-surface>
  </div>
</div>